<div class="form-subcontainer">
  <div class="form-content">
    <div>
      <form
      formName="transferBene"
        (ngSubmit)="confirm()"
        [formGroup]="formGroup"
        class="fpx-form-group"
      >
        <section class="from-sec">
          <h3 class="fpx-sec-title">
            {{ "OATTRANSFER.fromAccTitle" | translate }}
          </h3>
          <app-account-list
            [isDisabled]="state.favDisable"
            formControlName="debitAccNo"
            [disabled]="state.disableMode"
            [paymentType] = "state.paymentSystem"
          ></app-account-list>
          <!-- <div class="from-amount">
            {{ "OATTRANSFER.fromNewAmount" | translate }}
            {{ state.amountAfterDebit }}
            {{ "OATTRANSFER.fromAmountCurrency" | translate }}
          </div> -->
        </section>

        <section class="amount-sec">
          <div class="fpx-field">
            <app-amount
              [isDisabled]="state.favDisable"
				      [disabled]="state.disableMode"
              label="{{ 'OATTRANSFER.amount' | translate }}"
              [debitAccountNumber]="state.activeFromAccountNumber"
              [balanceCheck]="true"
              [errorType]="state.errorType"
              formControlName="amount"
              [selectableCurrencyList]="state.selectableCurrencyList"
            ></app-amount>
            <!-- <img src="./assets/images/between_account.svg" alt="" class="between-account-img"> -->
          </div>
        </section>

        <section class="to-sec" [ngClass]="{ 'disable-to-card': state.isnoMoreBeneAvailable }">
          <h3 class="fpx-sec-title">
            {{ "OATTRANSFER.toAccTitle" | translate }}
            <!-- <span class="to">To </span> -->
            <!-- <span class="to-amount">New amount: {{ state.amountAfterCredit }} EGP</span> -->
          </h3>
          <app-bene-card-list
            [isDisabled]="state.favDisable || state.disableMode"
            [type]="state.paymentSystem"
            [beneId]="state.beneId"
            formControlName="beneId"
          ></app-bene-card-list>
        </section>

        <section class="request-details-sec">
          <h3 class="fpx-sec-title"></h3>
          <div class="details-entry-panel">
            <div class="fpx-field ">
              <app-issue-date
                label="{{ 'OATTRANSFER.executionDate' | translate }}"
                isDisabled="true"
                formControlName="transferDate"
              ></app-issue-date>
            </div>
            <div class="fpx-field" *ngIf="state.allowScheduleTransfer">
              <app-save-as-favorite
                [isDisabled]="state.favDisable"
                label="{{ 'OATTRANSFER.scheduleTransfer' | translate }}"
                formControlName="isScheduled"
              ></app-save-as-favorite>
            </div>
            <ng-container *ngIf="state.showScheduledInfo">
              <div class="fpx-field">
                <app-frequency-transfer
                  label="{{ 'OATTRANSFER.frequencyOfTransfer' | translate }}"
                  formControlName="scheduleType"
                ></app-frequency-transfer>
              </div>
              <div class="fpx-field">
                <app-no-of-installment
                  label="{{ 'OATTRANSFER.noOfPayment' | translate }}"
                  placeholder="Installment count"
                  formControlName="noOfInstallment"
                ></app-no-of-installment>
              </div>
              <div class="fpx-field">
                <app-end-date
                  label="{{ 'OATTRANSFER.endDate' | translate }}"
                  [toggleDisabled]="true"
                  [changePublisher]="formChangePublisher$"
                  [dependentFields]="[
                    'transferDate',
                    'scheduleType',
                    'noOfInstallment'
                  ]"
                  formControlName="endDate"
                ></app-end-date>
              </div>
            </ng-container>
            <div class="fpx-field" [hidden]="state.hideRemarks">
              <app-remarks
                label="{{ 'OATTRANSFER.remarks' | translate }}"
                maxLength="50"
                formControlName="remarks"
              ></app-remarks>
            </div>

            <div [hidden]="requestReference" class="center-main">
              <ng-container *ngIf="!formGroup.disabled; else confirmTemplate">
                <section class="from-button-sec">
                  <button class="btn-link" (click)="reset()">
                    <span>{{ "FORM_ACTIONS.reset" | translate }}</span>
                  </button>
                </section>

                <section class="from-button-sec">
                  <button
                    type="button"
                    (click)="submit()"
                    class="button-common button40 active"
                    [disabled]="formGroup.invalid"
                  >
                    <span>{{ "FORM_ACTIONS.pay" | translate }}</span>
                  </button>
                </section>
              </ng-container>

              <ng-template #confirmTemplate>
                <section class="from-button-sec">
                  <button class="btn-link" (click)="edit()">
                    <span>{{ "FORM_ACTIONS.edit" | translate }}</span>
                  </button>
                </section>

                <section class="from-button-sec">
                  <button
                    type="submit"
                    class="button-common button40 active"
                    [disabled]="formGroup.invalid"
                  >
                    <span>{{ "FORM_ACTIONS.confirm" | translate }} </span>
                  </button>
                </section>
              </ng-template>
            </div>

            <!-- <section class="from-button-sec">
              <button
                class="button-common button40 active"
                [disabled]="formGroup.invalid"
                (click)="doSubmit(formGroup)"
              >
                <span>Submit</span>
              </button>
            </section> -->
          </div>
        </section>
      </form>
    </div>
  </div>
</div>